export enum VisitIncorrectItemType {
  Ingredient = 1,
  Product = 2,
}
